import { render, staticRenderFns } from "./SuggestionPappers.vue?vue&type=template&id=685058c5&"
import script from "./SuggestionPappers.vue?vue&type=script&lang=js&"
export * from "./SuggestionPappers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports